import React, { useState, useEffect } from 'react';
import appPromo from '../assets/app-promo.png';
const AppPromo = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const appPromoShown = localStorage.getItem('appPromoShown') === "true";
        const isMobileDevice = window.innerHeight > window.innerWidth * 1.2;
        if (!isMobileDevice) {
            return undefined;
        }

        const shouldShowPromo = !appPromoShown || Math.random() <= 0.05;
        if (!shouldShowPromo) {
            return undefined;
        }

        // Do not cover the page before a visitor has had a chance to see it.
        const timer = window.setTimeout(() => setIsVisible(true), 12000);
        return () => window.clearTimeout(timer);
    }, []);

    const hidePromo = () => {
        setIsVisible(false);
        localStorage.setItem('appPromoShown', 'true'); // Mark promo as shown in loca1lStorage
    };

    return (
        isVisible && (
            <div className="app-promo-backdrop" onClick={hidePromo}>
                <aside
                    className="app-promo"
                    role="dialog"
                    aria-modal="true"
                    aria-label="Приложение animix"
                    onClick={(event) => event.stopPropagation()}
                >
                    <button className="app-promo__close ui-close ui-close--sm ui-close--ghost" type="button" onClick={hidePromo} aria-label="Закрыть">×</button>
                    <img src={appPromo} alt="" />
                    <div className="app-promo__copy">
                        <strong>animix всегда рядом</strong>
                        <span>Смотрите в приложении — быстро и удобно</span>
                    </div>
                    <div className='buttonsapp'>
                        <button className='button-sec' type="button" onClick={hidePromo}>Не сейчас</button>
                        <a className='actionButton' href='https://play.google.com/store/apps/details?id=lol.animix.app'>Скачать</a>
                    </div>
                </aside>
            </div>
        )
    );
};

export default AppPromo;
